module.exports = __webpack_public_path__ + "img/酒星研酒所.7ce4528d.jpg";